const setLocalStorage = (key: string, value: any, expired = 3000000): boolean => {
  const data: Record<string, any> = { value, expired: Math.round(Date.now() / 1000) + expired };
  localStorage.setItem(key, JSON.stringify(data));
  return true;
};

const getLocalStorage = (key: string): boolean | any => {
  const cacheData: string | null = localStorage.getItem(key);
  if (cacheData === null) {
    return false;
  }
  const data: Record<string, any> = JSON.parse(cacheData);
  if (data.expired < Date.now() / 1000) {
    localStorage.removeItem(key);
    return false;
  }
  return data.value;
};

const removeLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

export { setLocalStorage, getLocalStorage, removeLocalStorage };
